module.exports = __webpack_public_path__ + "static/media/experience.ec1936a1.png";